import { Box, styled } from '@mui/material'
import React from 'react'
import AuthBackgroundImage from '../components/project/images/AuthBackgroundImage'
import GoTripLogo from '../components/project/images/GoTripLogo'
import { Outlet } from 'react-router'

const AuthLayout = () => {
  return (
    <AuthContainer>
      <LogoBox src={GoTripLogo} />
      <Outlet />
    </AuthContainer>
  )
}

const LogoBox = styled('img')(({ theme }) => ({
  width: '200px',
  marginBottom: theme.spacing(8)
}))

const AuthContainer = styled(Box)({
  width: '100vw',
  height: '100vh',
  backgroundImage: `url(${AuthBackgroundImage})`,
  backgroundSize: 'cover',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center'
})

export default AuthLayout
